<template>
  <div class="se-main">
    <div class="se-left">
      <el-input
        v-model="addDirForm.dirName"
        style="width: 100%"
        placeholder="请输入分类名称"
      ></el-input>
      <div>
        <el-button style="margin-left: 10px" type="text" @click="dirSearch"
          >查询</el-button
        >
        <el-button type="text" @click="resetDir">重置</el-button>
      </div>
      <div>所有题目分类</div>
      <div class="se-base-list se-m-t-10">
        <div
          v-for="(v, i) in dirList"
          :key="i"
          :class="['se-base-item', { active: active == i }]"
          @click="selectDir(v, i)"
        >
          <div class="se-base-item-title">{{ v.dirName }}</div>
        </div>
      </div>
    </div>
    <div class="se-right">
      <el-form :inline="true" :model="params" class="demo-form-inline">
        <el-form-item label="题型">
          <el-select v-model="params.questionType" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目名称">
          <el-input
            v-model="params.questionName"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="getTestList(params)"
            >查询</el-button
          >
          <el-button type="primary" @click="resetTest">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- @select="selectTable" -->
      <el-table
        v-loading="loading"
        :data="tableData"
        :row-key="handleReserve"
        :header-cell-class-name="cellClass"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" reserve-selection width="55">
        </el-table-column>
        <el-table-column prop="questionType" label="题型" width="180">
          <template slot-scope="scope">
            {{
              scope.row.questionType === 1
                ? "单选题"
                : scope.row.questionType === 2
                ? "多选题"
                : "填空题"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="questionName" show-overflow-tooltip label="题目" width="180">
        </el-table-column>
        <el-table-column prop="score" label="分值"> </el-table-column>
      </el-table>
      <div class="se-flex-h-c se-m-t-20">
        <el-pagination
          class="se-page"
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="params.pageNum"
          :page-size="params.pageSize"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dirList: [],
      active: undefined,
      options: [
        {
          label: "单选题",
          value: 1,
        },
        {
          label: "多选题",
          value: 2,
        },
        {
          label: "填空题",
          value: 3,
        },
      ],
      params: {
        questionType: null,
        pageNum: 1,
        pageSize: 10,
        enabled: 1,
        dirId: null,
        questionName: "",
      },
      addDirForm: {
        dirName: "",
        id: null,
      },
      total: 0,
      tableData: [],
      loading: false,
      dirName: "",
      // selectTest: [],
    };
  },

  created() {
    this.getTestDirList();
    this.getTestList();
  },

  methods: {
    cellClass(row) {
      // console.log(row, "row");
      if (row.columnIndex === 0) {
        //将第一行消除
        return "disabledCheck";
      }
    },
    //   获取题目分类
    async getTestDirList() {
      const data = await this.$http.get(
        "/server/api/dir/list",
        this.addDirForm
      );
      this.dirList = data.rows;
    },

    // 点击分类筛选
    selectDir(value, i) {
      this.active = i;
      this.params.dirId = value.id;
      this.getTestList();
    },

    // 获取题目列表
    async getTestList() {
      this.loading = true;
      const data = await this.$http.get(
        "/server/api/question/list",
        this.params
      );
      this.tableData = data.rows;
      this.total = data.total;
      this.loading = false;
    },

    // 分页回调
    currentChange(val) {
      this.params.pageNum = val;
      this.getTestList();
    },

    // 选择的题目
    handleSelectionChange(e) {
      // console.log(e, "e");
      this.$emit("selectTest", e);
    },

    // selectTable(selection, row) {
    //     console.log(selection, "selection");
    //     console.log(row, "row");
    //   this.$emit("selectTest", selection);
    // },

    // 设置rowKey
    handleReserve(row) {
      return row.id;
    },

    // 分类查询
    dirSearch() {
      this.getTestDirList();
    },

    // 重置分类
    resetDir() {
      this.addDirForm.dirName = "";
      this.params.pageNum = 1;
      this.active = undefined;
      this.params.dirId = null;
      this.getTestDirList();
      this.getTestList();
    },

    // 重置题目
    resetTest() {
      this.params.questionType = null;
      this.params.questionName = "";
      this.getTestList();
    },
  },
};
</script>

<style lang="scss" scoped>
.se-main {
  display: flex;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  min-height: 500px;
  width: 100%;
}

.se-left {
  width: 25%;
  height: auto;
  border-right: 1px solid #ccc;
  padding: 20px;
}

.se-right {
  width: 75%;
  height: auto;
  padding: 20px;
}

.se-base-item {
  cursor: pointer;
  margin-bottom: 5px;
}

.se-base-item:hover {
  background-color: #f1f1f1;
}

.active {
  background-color: #f1f1f1;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner[data-v-195384ee] {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409eff;
}

// 深度选择器 去掉全选按钮
// ::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
//   display: none;
// }

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
  line-height: 37px;
}
</style>
